module.exports = __webpack_public_path__ + "img/discord04.d855207.jpg";